import { useEffect, useState } from "react";
import { Box, keyframes } from "@mui/material";
import { useNavigate } from "react-router-dom";
import logo from "../../img/logo/Kairos-removebg-preview.webp";

const growAndColorize = keyframes`
  0%   { transform: scale(1); filter: brightness(1) hue-rotate(0deg) saturate(1); }
  100% { transform: scale(2); filter: brightness(0.95) hue-rotate(200deg) saturate(1.5); }
`;

const HomePricing = () => {
  const navigate = useNavigate();
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    const t1 = setTimeout(() => setFadeOut(true), 1600);
    const t2 = setTimeout(() => navigate("/projets", { replace: true }), 2200);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, [navigate]);

  return (
    <Box
      sx={{
        position: "fixed", inset: 0, zIndex: 9999,
        bgcolor: "#fff",
        display: "flex", alignItems: "center", justifyContent: "center",
        opacity: fadeOut ? 0 : 1,
        transition: "opacity 0.6s ease-out",
      }}
    >
      <Box
        component="img"
        src={logo}
        alt="Kairos"
        sx={{
          height: 64,
          width: "auto",
          objectFit: "contain",
          animation: `${growAndColorize} 1.4s cubic-bezier(0.4, 0, 0.2, 1) forwards`,
        }}
      />
    </Box>
  );
};

export default HomePricing;